import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CASE_STUDIES, GALLERY } from "@/data/site";

export type GalleryItem = { src: string; title: string; sector: string; service?: string; suburb?: string };
export type CaseStudy = {
  title: string; location: string; service: string; image: string; area: string; duration: string;
  challenge: string; solution: string; result: string;
};

export const mediaUrl = (id: string) => `${process.env.REACT_APP_BACKEND_URL}/api/media/${id}/image`;

type Content = { gallery: GalleryItem[]; caseStudies: CaseStudy[] };
let cache: Promise<Content> | null = null;

async function load(): Promise<Content> {
  const [g, c] = await Promise.all([api.get("/media", { params: { kind: "gallery" } }), api.get("/case-studies")]);
  const gallery: GalleryItem[] = g.data.map((m: any) => ({ src: mediaUrl(m.id), title: m.title, sector: m.sector || "Project", service: m.service, suburb: m.suburb }));
  const caseStudies: CaseStudy[] = c.data.map((x: any) => ({ ...x, image: x.image_id ? mediaUrl(x.image_id) : GALLERY[0].src }));
  return { gallery: gallery.length ? gallery : GALLERY, caseStudies: caseStudies.length ? caseStudies : CASE_STUDIES };
}

export function invalidateContent() {
  cache = null;
}

// Real uploaded content from CRM; falls back to placeholders until uploads exist.
export function useSiteContent(): Content {
  const [content, setContent] = useState<Content>({ gallery: [], caseStudies: [] });
  useEffect(() => {
    cache = cache || load().catch(() => ({ gallery: GALLERY, caseStudies: CASE_STUDIES }));
    cache.then(setContent);
  }, []);
  return content;
}
